<template>
  <div class="Authorization_management">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">

      <el-form-item label="综合查询">
        <el-input v-model="formInline.user" placeholder="请输入人员账号、姓名查询"></el-input>
      </el-form-item>

      <el-form-item label="创建时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.region" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>

    </el-form>

    <div class="nav">
      <el-button type="primary" class="btn" @click="dialogVisible = true,add()">添加授权</el-button>
      <el-table :data="tableData" style="width: 98%;margin-left:1%;margin-top:20px">
        <el-table-column prop="UserID" label="账号" ></el-table-column>
        <el-table-column prop="RealName" label="姓名"></el-table-column>
        <el-table-column label="是否启用" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.IsActive == '1' ? '启用' : '不启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreatedDate" label="账户创建时间"></el-table-column>
        <el-table-column prop="AuthorizationTime" label="授权期限"></el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <span @click="xgfun(scope.row)" class="w">修改</span>
            <span @click="delfun(scope.row.UserID)" class="w" style="margin-left:20px">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="PageIndex" :page-size="PageSize" layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>

    </div>

    <el-dialog title="授权" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item label="授权账号" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入授权账号" :disabled="type"></el-input>
        </el-form-item>

        <el-form-item label="授权期限" prop="time">
          <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="是否启用">
          <el-switch v-model="ruleForm.IsActive"></el-switch>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">{{ hz }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      hz:"立即创建",
      type:true,
      UndoCount: 1,
      PageIndex: 1,
      UserRoleKey:'',
      PageSize: 10,
      tableData: [],
      formInline: {
        user: '',
        region: []
      },
      ruleForm: {
        name: '',
        time: '',
        IsActive:true
      },
      rules: {
        name: [
          { required: true, message: '请输入授权账号', trigger: 'blur' },
        ],
        time: [
          { required: true, message: '请选择授权日期', trigger: 'blur' }
        ],

      },
      dialogVisible: false,
    }
  },
  methods: {
    resetfun() {
      this.formInline.user = '';
      this.formInline.region = '';
      this.PageIndex= 1;
      this.PageSize = 10;
      this.loading();
    },
    add() {
      this.ruleForm = {
        name: '',
        time: '',
        IsActive: true
      }
      this.type = false;
      this.UserRoleKey = '';
      this.hz = '立即创建';
    },
    xgfun(row) {
      console.log(row)
      this.hz = '立即修改';
      this.dialogVisible = true;
      this.ruleForm = {
        name: row.UserID,
        time: [row.AuthorizationTime.slice(0, 10), row.AuthorizationTime.slice(11, 22)],
        IsActive: row.IsActive == 1?true:false
      }
      this.UserRoleKey = row.UserRoleKey;
      this.type = true;

    },
    delfun(row) {
      this.$Http_Post('management/delAuthorizationManagement', { UserID: row }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    onSubmit() {
      this.PageIndex = 1;
      this.loading();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.loading();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => { });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.iscontinuous = true
          var Type = ''
          if(this.hz == '立即创建'){
            Type = 0
          }else{
            Type = 1
          }
          this.$Http_Post('management/changePermissions', { RoleID :'1067', UserID :this.ruleForm.name , StartTime :this.ruleForm.time[0], EndTime: this.ruleForm.time[1], IsActive : this.ruleForm.IsActive ?"1":"0", UserRoleKey:this.UserRoleKey,Type:Type }, { 'Content-Type': 'multipart/form-data'}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.iscontinuous = false
              this.Global.request_successful(res.Message);
              this.dialogVisible = false;
              this.loading();
            } else {
              this.iscontinuous = false
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    loading() {
      this.$Http_Post('management/authorizationManagementList', { PageIndex: this.PageIndex, PageSize: this.PageSize, Name: this.formInline.user, StartTime :this.formInline.region[0], EndTime: this.formInline.region[1] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.UndoCount = res.Counts;
          this.tableData = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted() {
    this.loading()
  },
}
</script>
<style>
.Authorization_management{width: 100%;height: 100%;}
.Authorization_management .demo-form-inline{background-color: #fff;padding: 20px;}
.Authorization_management .nav{background-color: #fff;height: calc(100% - 120px);width: 100%;margin-top: 15px;}
.Authorization_management .btn{margin-left: 20px;margin-top: 20px;}
.Authorization_management .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{width: 300px;}
.Authorization_management .el-form-item__content{width: 300px;}
.Authorization_management .el-range-editor.el-input__inner{width: 300px;}
</style>
